import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import PlaceBet from "../../components/PlaceBet";
import Bookmaker from "../Bookmaker";
import LiveTV from "../LiveTV";
import AllBetList from "../../components/AllBetList/AllBetList";
import { useParams, useNavigate } from "react-router-dom";
import actions from "../../redux/actions";
import { useSelector } from "react-redux";
import Navbar from "../../components/navbar";
import * as MdIcons from "react-icons/md";
import FancyBets from "../FancyBets";
import { useToast } from "../../components/ToastContext";
import ProgressIndicator from "../../components/ProgressIndicator";
//import FooterMenu from '../../components/FooterMenu';
import wBetSound from "./raw/wrong.mp3";
import {
  setCustomeBMList,
  setEventBetLock,
  setFancyActiveList,
  saveBetfareRetsBMAndFancy,
  saveBfRMarketOdddsOther,
} from "../../redux/slices/marketSlice";
import sBetSound from "./raw/yipee.mp3";
import { isBetSound } from "../../utilities";

import signalRService from "../../services/SignalRService2";
import socketService from "../../services/socketService";
import { USE_SOCKET_FOR_BM_AND_FANCY, getApiUrl } from "../../services/url";
import "./style.css";
import store from "../../redux/store";
import FancyCurrentPostionModal from "../../components/Modal/FancyCurrentPostionModal";
import BetBookModal from "../../components/Modal/BetBookModal";
const Market = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [isPlacingBet, setIsPlacingBet] = useState(false);
  const [showPlaceBet, setShowPlaceBet] = useState(false);
  const [isLoadingBet, setIsLoadingBet] = useState(false);
  const [typeOfPlaceBet, setTypeOfPlaceBet] = useState(null);
  const [selectType, setSelectType] = useState(null);
  const [oddsPrice, setOddsPrice] = useState(0);
  const [oddsSize, setOddsSize] = useState(null);
  const [marketType, setmarketType] = useState(null);
  const [marketID, setmarketID] = useState(null);
  const [runnerName, setRunnerName] = useState(null);
  const [selectedMarkets, setSelectedMarkets] = useState(["All"]);
  const [cashoutData, setCashoutData] = useState(null);
  const [data, setData] = useState({
    Exposure: 1,
    ReturnBalance: 0,
    UserId: 0,
    BetStatus: "Pending",
  });
  const { eventId, sportId } = useParams();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const { showToast } = useToast();

  const evmarketList = useSelector(
    (state) => state.marketSlice.eventDetailData.Result,
  );
  const fancyOddsFareRate = useSelector(
    (state) => state.marketSlice.BetfareRetsBMAndFancyData?.fancy,
  ); //fancy
  const fancyprofitLossData = useSelector(
    (state) => state.marketSlice.fancyPostionData?.Result,
  );

  const activeFancyList = useSelector(
    (state) => state.marketSlice.fancyActiveList,
  ); //fancy
  const eventDetail = evmarketList?.MarketList;
  const fancySetting = evmarketList?.fancy;

  var filteredMainlist = [];

  useEffect(() => {
    store.dispatch(setEventBetLock(fancySetting?.EvBetStatus));
  }, [fancySetting?.EvBetStatus]);

  if (fancySetting?.IsFancyActive) {
    if (fancyOddsFareRate)
      filteredMainlist = JSON.parse(JSON.stringify(fancyOddsFareRate));
    if (filteredMainlist) {
      filteredMainlist.forEach((item) => {
        item.min = fancySetting?.SessionMinStake;
        item.max = fancySetting?.SessionMaxStake;
        item.IsCom = false;
      });
    }

    if (
      fancyOddsFareRate &&
      typeof fancyOddsFareRate[Symbol.iterator] === "function"
    ) {
      activeFancyList.forEach((activelistItem) => {
        // Check if SelectionId is not present in filteredMainlist
        const index = filteredMainlist.findIndex(
          (item) => item.SelectionId === activelistItem.SelectionId,
        );

        if (
          !filteredMainlist.some(
            (item) => item.SelectionId === activelistItem.SelectionId,
          )
        ) {
          // Push the entire activelistItem to filteredMainlist
          //filteredMainlist.push(activelistItem);
          if (activelistItem.isCustome && activelistItem.isActive)
            filteredMainlist.unshift(activelistItem);
        } else {
          // Find the index of the matching item in filteredMainlist
          if (activelistItem.isCustome) {
            // Replace the values of the matching item in filteredMainlist
            filteredMainlist[index] = {
              ...filteredMainlist[index],
              LayPrice1: activelistItem.LayPrice1,
              LaySize1: activelistItem.LaySize1,
              BackPrice1: activelistItem.BackPrice1,
              BackSize1: activelistItem.BackSize1,
              GameStatus: activelistItem.GameStatus,
              max: activelistItem.max,
              min: activelistItem.min,
            };
          } else {
            if (!activelistItem.isActive) {
              const item = filteredMainlist.findIndex(
                (item) => item.SelectionId === activelistItem.SelectionId,
              );
              filteredMainlist.splice(item, 1);
            } else {
              filteredMainlist[index] = {
                ...filteredMainlist[index],
                max: activelistItem.max,
                min: activelistItem.min,
                IsCom: activelistItem.IsCom,
              };
            }
          }
        }
      });
    } else {
      //console.log("fancyOddsFareRate is not defined or not iterable.");
    }
    //console.log("Active fancy true");
  } else {
    if (
      fancyOddsFareRate &&
      typeof fancyOddsFareRate[Symbol.iterator] === "function"
    ) {
      activeFancyList.forEach((activelistItem) => {
        // Check if SelectionId is not present in filteredMainlist

        if (
          !fancyOddsFareRate.some(
            (item) =>
              item.SelectionId === activelistItem.SelectionId &&
              activelistItem.isCustome,
          )
        ) {
          if (activelistItem.isCustome) {
            // filteredMainlist.push(activelistItem);
            filteredMainlist.unshift(activelistItem);
          }
        }

        if (activelistItem.isActive) {
          const item = fancyOddsFareRate.find(
            (item) => item.SelectionId === activelistItem.SelectionId,
          );
          if (item) {
            Object.freeze(item);
            const objCopy = { ...item }; // 👈️ create copy
            objCopy.max = activelistItem.max;
            objCopy.min = activelistItem.min;
            filteredMainlist.push(objCopy);
          }
        }
        // Find the index of the matching item in filteredMainlist
        if (activelistItem.isCustome) {
          const index = filteredMainlist.findIndex(
            (item) => item.SelectionId === activelistItem.SelectionId,
          );
          // Replace the values of the matching item in filteredMainlist
          filteredMainlist[index] = {
            ...filteredMainlist[index],
            LayPrice1: activelistItem.LayPrice1,
            LaySize1: activelistItem.LaySize1,
            BackPrice1: activelistItem.BackPrice1,
            BackSize1: activelistItem.BackSize1,
            GameStatus: activelistItem.GameStatus,
            max: activelistItem.max,
            min: activelistItem.min,
          };
        }
      });

      //console.log("Active fancy false");
    } else {
      //console.log("fancyOddsFareRate is not defined or not iterable.");
    }
  }
  useEffect(() => {
    signalRService.startConnection();

    signalRService.addListener("UpdateMarketList", (message) => {
      // setUpdateMarketListData(prevData => [...prevData, data]);
    });

    signalRService.addListener("GetActiveBM", (message) => {
      var master = JSON.stringify(eval("(" + message + ")"));
      var data = JSON.parse(master);
      if (data.Marketid === marketID + "B") {
        store.dispatch(setCustomeBMList(data.BMList));
      }
      //setGetActiveBMData(prevData => [...prevData, data]);
    });

    signalRService.addListener("GetActiveSession", (message) => {
      var master = JSON.stringify(eval("(" + message + ")"));
      var data = JSON.parse(master);
      if (data.Marketid === marketID) {
        store.dispatch(setFancyActiveList(data.fancyList));
      }
      //setGetActiveSessionData(prevData => [...prevData, data]);
    });
    signalRService.addListener("EventSuspended", (message) => {
      console.log("Event Suspended");
      var master = JSON.stringify(eval("(" + message + ")"));
      var data = JSON.parse(master);
      if (data.EventId === eventId) {
        actions.getEventDetail(eventId);
      }
      //setGetActiveSessionData(prevData => [...prevData, data]);
    });
    signalRService.addListener("inplaycount", (message) => {
      // setInplaycountData(prevData => [...prevData, data]);
    });

    signalRService.addListener("updateNews", (message) => {
      //   setUpdateNewsData(prevData => [...prevData, data]);
    });

    signalRService.addListener("BetPlacedMessage", (message) => {
      var master = JSON.stringify(eval("(" + message + ")"));
      var data = JSON.parse(master);

      if (data.EventId === eventId) {
        var marketid = data.MarketId;
        var mktype = data.MarketType;
        var BMID = marketid.replace("B", "");
        if (mktype === "FANCY") {
          actions.GetFancyPostionList(BMID);
          // call getFancyPosition api
        } else {
          //call getProfitLossOnRunners pass marketid
          actions.GetProfitLossOnRunnersList(BMID, sportId);
        }
        // call bet list api
        actions.GetMatchedBetList(data.EventId);
      }
    });

    return () => {
      signalRService.connection.stop();
    };
  }, [marketID, eventId]);

  useEffect(() => {
    // Fetch data and set marketID based on eventDetail
    if (eventDetail && eventDetail.length > 0 && eventDetail !== undefined) {
      var bm = eventDetail.find((obj) => obj.MarketType === "Bookmaker");
      if (sportId === "4") {
        if (bm !== undefined) {
          var MID = bm.MarketId.replace("B", "");
          setmarketID(MID);
          actions.getactiveFancyList(MID);
          actions.getCustomeBMList(MID);
          actions.GetFancyPostionList(MID);
        } else {
          var MID = eventDetail[0].MarketId;
          setmarketID(MID);
          actions.getactiveFancyList(MID);
          actions.getCustomeBMList(MID);
          actions.GetFancyPostionList(MID);
        }
      }
    }
  }, [eventDetail]);

  useEffect(() => {
    actions.getactiveFancyList(marketID);
    actions.getCustomeBMList(marketID);
  }, [marketID]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    if (showPlaceBet) {
      timeoutRef.current = setTimeout(() => {
        setShowPlaceBet(false);
      }, 10000); // Hide after 10 seconds
    } else {
      setCashoutData(null); // Auto-clears projected book when popup closes or hides
    }
    return () => clearTimeout(timeoutRef.current);
  }, [showPlaceBet]);

  /// handle Show PlaceBet Box When hide
  const handleShowPlaceBet = (
    placeBetType,
    backOddsPrice,
    marketType,
    backOddsSize,
  ) => {
    setTypeOfPlaceBet(placeBetType);
    if (oddsPrice !== undefined) {
      setShowPlaceBet(true);
      timeoutRef.current = setTimeout(() => {
        setShowPlaceBet(false);
      }, 10000);
    } else {
      setShowPlaceBet(false);
    }
  };

  const handleShowBackPlaceBet = (selectBet, runner, market, runr) => {
    setCashoutData(null);
    //   const matchRunner = market?.runners.find(runner2 => runner2?.selectionId.toString() === runner?.selectionId.toString());
    setSelectType(selectBet);
    setmarketType(market?.MarketType);
    setOddsPrice(runner?.ex.availableToBack[0]?.price);
    setRunnerName(runr.RunnerName);
    handleShowPlaceBet(
      0,
      runner?.ex.availableToBack[0]?.price,
      market?.MarketType,
      0,
    );
    setData({
      ...data,
      sportsId: market.SportsId,
      SelectionName: runr.RunnerName,
      SelectionID: runr.id.toString(),
      Odds: runner?.ex.availableToBack[0]?.price,
      Price: 0,
      OldPrice: runner?.ex.availableToBack[0]?.price,
      MarketType: market?.MarketType,
      MarketId: market?.MarketId,
      EventId: eventId,
      BetType: "Back",
    });
  };

  const handleShowLayPlaceBet = (selectBet, runner, market, runr) => {
    setCashoutData(null);
    // const matchRunner = market?.runners.find(runner2 => runner2?.selectionId.toString() === runner?.selectionId.toString());
    setmarketType(market?.MarketType);
    setSelectType(selectBet);
    setOddsPrice(runner?.ex.availableToLay[0]?.price);
    setRunnerName(runr.RunnerName);
    handleShowPlaceBet(
      1,
      runner?.ex.availableToLay[0]?.price,
      market?.MarketType,
      0,
    );
    setData({
      ...data,
      sportsId: market.SportsId,
      SelectionName: runr.RunnerName,
      SelectionID: runr.id.toString(),
      Odds: runner?.ex.availableToLay[0]?.price,
      Price: 0,
      MarketType: market?.MarketType,
      MarketId: market?.MarketId,
      EventId: eventId,
      BetType: "Lay",
    });
  };

  const handleShowBackPlaceBetFancy = (selectBet, runner) => {
    setSelectType(selectBet);
    setmarketType("FANCY");
    setOddsSize(runner?.BackSize1);
    setOddsPrice(runner.BackPrice1);
    setRunnerName(runner.RunnerName);
    handleShowPlaceBet(0, runner.BackPrice1, "FANCY", runner?.BackSize1);
    setData({
      ...data,
      sportsId: sportId,
      SelectionName: runner.RunnerName,
      SelectionID: runner.SelectionId,
      Odds: runner.BackPrice1,
      OldStack: runner.BackPrice1,
      Price: runner.BackSize1,
      OldPrice: runner.BackSize1,
      MarketType: "FANCY",
      MarketId: eventDetail[0]?.MarketId,
      EventId: eventId,
      BetStatus: "Pending",
      BetType: "Yes",
    });
  };

  const handleShowLayPlaceBetFancy = (selectBet, runner) => {
    setSelectType(selectBet);
    setmarketType("FANCY");
    setOddsSize(runner?.LaySize1);
    setOddsPrice(runner.LayPrice1);
    setRunnerName(runner.RunnerName);
    handleShowPlaceBet(1, runner?.LayPrice1, "FANCY", runner?.LaySize1);
    setData({
      ...data,
      sportsId: sportId,
      SelectionName: runner.RunnerName,
      SelectionID: runner.SelectionId,
      Odds: runner.LayPrice1,
      OldStack: runner.LayPrice1,
      Price: runner.LaySize1,
      OldPrice: runner.LaySize1,
      MarketType: "FANCY",
      MarketId: eventDetail[0]?.MarketId,
      EventId: eventId,
      BetStatus: "Pending",
      BetType: "No",
    });
  };
  const handleCashoutClick = (cashout) => {
    if (!cashout) return;
    setCashoutData(cashout);
    setmarketType(cashout.marketType);
    setSelectType(0);
    setOddsPrice(cashout.odds);
    setRunnerName(cashout.runnerName);
    setTypeOfPlaceBet(cashout.typeOfPlaceBet);
    setShowPlaceBet(true);
    setData({
      ...data,
      sportsId: cashout.market?.SportsId || sportId,
      SelectionName: cashout.runnerName,
      SelectionID: cashout.runner?.id
        ? cashout.runner.id.toString()
        : cashout.selectionId.toString(),
      Odds: cashout.odds,
      Stack: cashout.stake,
      OldStack: cashout.stake,
      Exposure: cashout.stake,
      Price: 0,
      OldPrice: cashout.odds,
      MarketType: cashout.marketType,
      MarketId: cashout.marketId,
      EventId: eventId,
      BetType: cashout.betType,
    });
  };

  // Delay between API calls in seconds
  const delayInSeconds = 2;

  // Helper: Fetch Manual Cup Rate from local WebAPI
  const getManualCupRateData = async (marketId) => {
    try {
      const targetId = marketId?.split(",")[0] || marketId;
      const res = await axios.get(getApiUrl(`/api/ManualRate/betfair/${targetId}`));
      if (res?.data) {
        store.dispatch(saveBfRMarketOdddsOther(res.data));
      }
    } catch (err) {
      console.error("Error fetching Cup Rate:", err);
    }
  };

  // Function to fetch data from API and repeat it
  const fetchRetsBMAndFancyRepeat = async () => {
    if (eventDetail && eventDetail?.length > 0 && eventDetail !== undefined) {
      var bm = eventDetail.find((obj) => obj.MarketType === "Bookmaker");
      const marketids = eventDetail.map((market) =>
        market?.MarketId.replace(/[TB]+$/, ""),
      );
      const uniqueMarketids = new Set(marketids);
      const queryString = [...uniqueMarketids].join(",");

      try {
        const isCupRate = eventDetail?.some(
          (m) => m?.SeriesName?.toLowerCase() === "cup rate"
        );
        if (isCupRate) {
          getManualCupRateData(queryString);
        } else {
          actions.getBetfareRetsMarketAndOther(queryString);
        }
        if (bm !== undefined) {
          var BMID = bm.MarketId.replace("B", "");
          if (sportId === "4") {
            // actions.getBetfareRetsBMAndFancy(BMID); // Original API polling (commented to allow running with WebSockets)
            if (!USE_SOCKET_FOR_BM_AND_FANCY) {
              actions.getBetfareRetsBMAndFancy(BMID);
            }
            actions.getBetfareTossOdds(BMID);
            //actions.GetFancyPostionList(BMID);
          }
        } else {
          var BMID = eventDetail[0].MarketId.replace("B", "");
          if (sportId === "4") {
            // actions.getBetfareRetsBMAndFancy(BMID); // Original API polling (commented to allow running with WebSockets)
            if (!USE_SOCKET_FOR_BM_AND_FANCY) {
              actions.getBetfareRetsBMAndFancy(BMID);
            }
            actions.getBetfareTossOdds(BMID);
            // actions.GetFancyPostionList(BMID);
          }
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }
  };

  useEffect(() => {
    // Call the API immediately when the component mounts
    fetchRetsBMAndFancyRepeat();

    // Set up an interval to repeatedly call the API
    const intervalId = setInterval(() => {
      fetchRetsBMAndFancyRepeat();
    }, delayInSeconds * 1000); // Call the function every `delayInSeconds` seconds

    // Cleanup the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [eventDetail, sportId]);

  useEffect(() => {
    if (marketID && USE_SOCKET_FOR_BM_AND_FANCY) {
      const handleOddsUpdate = (oddsData) => {
        store.dispatch(saveBetfareRetsBMAndFancy(oddsData));
      };

      console.log(
        "Subscribing to real-time WebSocket odds for market:",
        marketID,
      );
      socketService.subscribe(marketID, handleOddsUpdate);

      return () => {
        console.log(
          "Unsubscribing from real-time WebSocket odds for market:",
          marketID,
        );
        socketService.unsubscribe(handleOddsUpdate);
      };
    }
  }, [marketID]);

  useEffect(() => {
    const intervalId = setInterval(
      () => {
        actions.GetMatchedBetList(eventId);
      },
      delayInSeconds * 30 * 1000,
    ); // Call the function every `delayInSeconds` seconds
    return () => {
      clearInterval(intervalId);
    };
  }, [eventId]);

  useEffect(() => {
    actions.getEventDetail(eventId);
    actions.getChipModal();
    actions.GetMatchedBetList(eventId);
  }, [eventId]);

  useEffect(() => {
    if (eventDetail?.length > 0) {
      const allOptions = [
        ...eventDetail.map((m) => m.MarketType),
        "Fancy",
        "All",
      ];
      setSelectedMarkets(allOptions);
    }
  }, [eventDetail]);

  const handleCancelClick = () => {
    setShowPlaceBet(false);
    setCashoutData(null);
  };

  const handleSubmitPlaceBet = async (totalstack, type) => {
    if (totalstack > 0) {
      setIsLoadingBet(true);
      setIsPlacingBet(true);
      const updatedData = {
        ...data,
        Stack: totalstack,
        OldStack: totalstack,
        Exposure: totalstack,
        ReturnBalance: type,
      };
      try {
        if (selectType === 0) {
          const response = await actions.postUserBetAPI(updatedData); // Add 'await' here
          showToast(
            response?.data?.Result,
            response?.data?.Status ? "success" : "error",
          );
          if (response?.data?.Status) {
            actions.GetUserBalanceAction();
            actions.GetMatchedBetList(eventId);
            actions.GetProfitLossOnRunnersList(updatedData.MarketId, sportId);
            actions.getEventDetail(eventId);
            if (isBetSound()) new Audio(sBetSound).play();
          } else {
            if (isBetSound()) new Audio(wBetSound).play();
          }
        } else {
          const response = await actions.postFancyBetAPI(updatedData);
          showToast(
            response?.data?.Result,
            response?.data?.Status ? "success" : "error",
          );

          if (response?.data?.Status) {
            actions.GetUserBalanceAction();
            actions.GetMatchedBetList(eventId);
            actions.GetFancyPostionList(updatedData.MarketId);
            actions.getEventDetail(eventId);
            if (isBetSound()) new Audio(sBetSound).play();
          } else {
            if (isBetSound()) new Audio(wBetSound).play();
          }
        }
      } catch (error) {
        console.log("Error:", error);
        if (isBetSound()) new Audio(wBetSound).play();
      } finally {
        setIsLoadingBet(false);
        setIsPlacingBet(false);
        setShowPlaceBet(false);
        setCashoutData(null);
      }
    } else {
      // when totalstack is not greater than 0
      showToast("Total stack must be greater than 0", "error");
      if (isBetSound()) new Audio(wBetSound).play();
    }
  };

  const handleMarketFilterChange = (type) => {
    setSelectedMarkets((prev) => {
      const allOptions = [...eventDetail?.map((m) => m.MarketType), "Fancy"];

      if (type === "All") {
        if (prev.includes("All")) return [];
        return [...allOptions, "All"];
      }

      let updated = [];
      if (prev.includes(type)) {
        updated = prev.filter((m) => m !== type);
      } else {
        updated = [...prev.filter((m) => m !== "All"), type];
      }

      const individualOptions = allOptions.filter((opt) => opt !== "All");
      if (individualOptions.every((opt) => updated.includes(opt))) {
        updated = [...individualOptions, "All"];
      } else {
        updated = updated.filter((m) => m !== "All");
      }

      return updated;
    });
  };

  return (
    <>
      <div className="container-fluid ">
        <Navbar hideToggle="true" />
        <div className="d-flex flex-wrap" style={{ marginTop: "100px" }}>
          <div className="col-12 col-md-8 scrollable-content">
            <div className="scrollable-content-inner">
              <button
                className="btn violet_button"
                onClick={() => navigate("/home")}
              >
                <MdIcons.MdArrowBackIos />
                Back
              </button>
              {isMobile && <LiveTV />} {/* Show LiveTV only in mobile view */}
              <div
                className="container d-flex p-1 mt-2"
                style={{
                  background: "#fff",
                  gap: "1rem",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                <div className="form-check d-inline-block">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="all"
                    checked={selectedMarkets.includes("All")}
                    onChange={() => handleMarketFilterChange("All")}
                  />
                  <label className="form-check-label" htmlFor={`all`}>
                    All
                  </label>
                </div>
                {/* Dynamic MarketTypes */}
                {eventDetail?.map((market) => (
                  <div
                    key={market.MarketId}
                    className="form-check d-inline-block"
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`market-${market.MarketId}`}
                      checked={selectedMarkets.includes(market.MarketType)}
                      onChange={() =>
                        handleMarketFilterChange(market.MarketType)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`market-${market.MarketId}`}
                    >
                      {market.MarketType}
                    </label>
                  </div>
                ))}
                {/* Fancy */}
                <div className="form-check d-inline-block">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="fancy"
                    checked={selectedMarkets.includes("Fancy")}
                    onChange={() => handleMarketFilterChange("Fancy")}
                  />
                  <label className="form-check-label" htmlFor="fancy">
                    Fancy
                  </label>
                </div>
              </div>
              {eventDetail?.length && (
                <Bookmaker
                  eventDetail={eventDetail}
                  handleShowBackPlaceBet={handleShowBackPlaceBet}
                  handleShowLayPlaceBet={handleShowLayPlaceBet}
                  selectedMarkets={selectedMarkets}
                  cashoutData={cashoutData}
                  handleCashoutClick={handleCashoutClick}
                />
              )}
              {sportId === "4" && selectedMarkets.includes("Fancy") && (
                <FancyBets
                  fancyprofitLossData={fancyprofitLossData}
                  fancyOddsFareRate={filteredMainlist}
                  handleShowBackPlaceBet={handleShowBackPlaceBetFancy}
                  handleShowLayPlaceBet={handleShowLayPlaceBetFancy}
                  marketID={marketID}
                />
              )}
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="fixed-height-content">
              {!isMobile && <LiveTV />} {/* Show LiveTV only in desktop view */}
              {showPlaceBet && (
                <div className="PlaceBet">
                  <PlaceBet
                    isLoading={isLoadingBet}
                    oddsPrice={oddsPrice}
                    runnerName={runnerName}
                    marketType={marketType}
                    oddsSize={oddsSize}
                    typeOfPlaceBet={typeOfPlaceBet}
                    handleCancelClick={handleCancelClick}
                    handleSubmitPlaceBet={handleSubmitPlaceBet}
                    cashoutData={cashoutData}
                  />
                </div>
              )}
              <AllBetList eventId={eventId} />
            </div>
            {isPlacingBet && isMobile && <ProgressIndicator />}
          </div>
        </div>
        {/* <FooterMenu /> */}
      </div>
      <FancyCurrentPostionModal />
      <BetBookModal />
    </>
  );
};

export default Market;
